var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F0F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1602 11.75L16.1133 8.82422C16.2773 8.66016 16.2773 8.35938 16.1133 8.19531L15.4297 7.51172C15.2656 7.34766 14.9648 7.34766 14.8008 7.51172L11.875 10.4648L8.92188 7.51172C8.75781 7.34766 8.45703 7.34766 8.29297 7.51172L7.60938 8.19531C7.44531 8.35938 7.44531 8.66016 7.60938 8.82422L10.5625 11.75L7.60938 14.7031C7.44531 14.8672 7.44531 15.168 7.60938 15.332L8.29297 16.0156C8.45703 16.1797 8.75781 16.1797 8.92188 16.0156L11.875 13.0625L14.8008 16.0156C14.9648 16.1797 15.2656 16.1797 15.4297 16.0156L16.1133 15.332C16.2773 15.168 16.2773 14.8672 16.1133 14.7031L13.1602 11.75Z",
    fill: "#233145"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clearIcon.a930cf42.svg";
export { ForwardRef as ReactComponent };